<div class="modal-body justify-content-center">
  <div class="cm-header-section">
    <h5 class="modal-title" id="studioInquiryModalLabel">{{constants.modalTitle}}</h5>
    <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
      <span class="cm-close-text">{{constants.close}}</span>
    </button>
  </div>

  <div class="si-main-container">
    <form [formGroup]="servicesForm" (ngSubmit)="onNext()">
      <div class="si-services-section">
        <h2 class="si-section-title">{{constants.servicesTitle}}</h2>

        <div class="si-services-list">
          <div class="si-services-column" *ngFor="let column of serviceColumns">
            <div class="si-service" *ngFor="let service of column">
              <div class="common-checkbox-button si-service-name">
                <input type="checkbox" class="common-checkbox-input" [id]="'service-' + service.id"
                  [formControlName]="service.id" />
                <label class="common-checkbox-label si-service-label" [for]="'service-' + service.id">
                  {{service.name}}
                </label>
              </div>
              <p class="si-service-detail" *ngIf="service.detail">{{service.detail}}</p>
            </div>
          </div>
        </div>

        <a class="si-services-link" [href]="constants.studioServicesUrl" target="_blank" rel="noopener">
          {{constants.studioServicesLink}}
          <img src="../assets/images/link-icon.svg" alt="" class="si-services-link-icon">
        </a>
      </div>

      <div class="si-btn-section">
        <button type="submit" class="btn common-btn-secondary" [disabled]="!selectedServices.length">
          {{constants.next}}
        </button>
      </div>
    </form>
  </div>
</div>
